// import { makeRequest } from '../utils/index.ts';
var _a;
function isArray(obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
}
export var TYPE_MAP;
(function (TYPE_MAP) {
    TYPE_MAP[TYPE_MAP["UINT8"] = 1] = "UINT8";
    TYPE_MAP[TYPE_MAP["UINT16"] = 2] = "UINT16";
    TYPE_MAP[TYPE_MAP["UINT32"] = 3] = "UINT32";
    TYPE_MAP[TYPE_MAP["UINT64"] = 4] = "UINT64";
    TYPE_MAP[TYPE_MAP["STRING"] = 5] = "STRING";
    TYPE_MAP[TYPE_MAP["VECTOR_STRING"] = 6] = "VECTOR_STRING";
    TYPE_MAP[TYPE_MAP["MAP_STRING"] = 7] = "MAP_STRING";
    TYPE_MAP[TYPE_MAP["VECTOR_STRUCT"] = 8] = "VECTOR_STRUCT";
})(TYPE_MAP || (TYPE_MAP = {}));
var TYPE_MAP_DEFAULT = (_a = {},
    _a[TYPE_MAP.UINT8] = 0,
    _a[TYPE_MAP.UINT16] = 0,
    _a[TYPE_MAP.UINT32] = 0,
    _a[TYPE_MAP.UINT64] = 0,
    _a[TYPE_MAP.STRING] = '',
    _a[TYPE_MAP.VECTOR_STRING] = '',
    _a[TYPE_MAP.MAP_STRING] = '',
    _a[TYPE_MAP.VECTOR_STRUCT] = '',
    _a);
var BGReport = /** @class */ (function () {
    function BGReport(_a) {
        var uri = _a.uri, aid = _a.aid, model = _a.model;
        this.params = {};
        this.uri = String(uri);
        this.aid = String(aid);
        this.model = model;
    }
    BGReport.prototype.processVal = function (val, type) {
        switch (type) {
            case TYPE_MAP.UINT8:
            case TYPE_MAP.UINT16:
            case TYPE_MAP.UINT32:
            case TYPE_MAP.UINT64: {
                // // todo 检查是否超出最大值
                // if (type === BGReport.TYPE_UINT64) {
                //   // 如果是uint64,则直接以字符串形式传入
                //   console.info('not fully support uInt64 now, report may failed, try to use string');
                // } else {
                //   val = parseInt(val, 10);
                // }
                val = parseInt(val, 10);
                break;
            }
            case TYPE_MAP.STRING: {
                val = '' + val;
                break;
            }
            case TYPE_MAP.VECTOR_STRING: {
                var tmp = [];
                if (isArray(val)) {
                    for (var i = 0, len = val.length; i < len; i++) {
                        tmp.push(this.processVal(val[i], TYPE_MAP.STRING));
                    }
                    val = tmp;
                }
                else {
                    throw new Error('invalid data type of array');
                }
                break;
            }
            case TYPE_MAP.MAP_STRING: {
                var tmpMap = {}, seq = 1;
                // map的seq顺序实际上没什么效果，所以直接递增
                for (var k in val) {
                    if (val.hasOwnProperty(k)) {
                        tmpMap[k] = {
                            value: '' + val[k],
                            seq: seq
                        };
                        seq++;
                    }
                }
                val = tmpMap;
                break;
            }
            case TYPE_MAP.VECTOR_STRUCT: {
                // json形式的上报，只支持一个分组，即[{ Field, Field}]，不支持[{ Field, Field}, { Field, Field}]，即数组只有一个元素
                var tmpStruct = {};
                for (var j in val) {
                    if (val.hasOwnProperty(j) && val[j] instanceof BGField) {
                        tmpStruct[val[j].key] = this.formatField(val[j]);
                    }
                }
                val = [tmpStruct];
                break;
            }
            default:
                console.error(val, type);
                throw new Error('invalid type');
        }
        return val;
    };
    BGReport.prototype.formatField = function (field) {
        var obj;
        if (field instanceof BGField) {
            obj = {
                value: this.processVal(field.val, field.type),
                type: field.type,
                seq: field.seq
            };
            return obj;
        }
        else {
            console.error(field);
            throw new Error('invalid field param');
        }
    };
    BGReport.prototype.writeField = function (field) {
        if (field instanceof BGField) {
            this.params[field.key] = this.formatField(field);
        }
        else {
            console.error(field);
            throw new Error('invalid field param');
        }
    };
    BGReport.prototype.setUrl = function (url) {
        BGReport.REPORT_URL = url;
    };
    BGReport.prototype.getUrl = function () {
        return BGReport.REPORT_URL.replace('#URI#', this.uri)
            .replace('#AID#', this.aid);
    };
    BGReport.prototype.format = function (params) {
        var _this = this;
        var result = {};
        Object.keys(this.model).reduce(function (result, key) {
            result[key] = params[key] || TYPE_MAP_DEFAULT[_this.model[key].type];
            _this.writeField(new BGField(key, result[key], _this.model[key].type, _this.model[key].seq));
            return result;
        }, result);
        return this.params;
    };
    BGReport.TYPE_MAP = TYPE_MAP;
    BGReport.REPORT_URL = '//support-json.like.video/json?uri=#URI#&aid=#AID#';
    return BGReport;
}());
var BGField = /** @class */ (function () {
    function BGField(key, val, type, seq) {
        this.key = key;
        this.val = val;
        this.type = type;
        this.seq = parseInt(seq, 10);
        if (type === TYPE_MAP.VECTOR_STRUCT
            && !isArray(val)) {
            throw new Error('struct/map need param to be array');
        }
    }
    return BGField;
}());
export default BGReport;
